export enum PlayerStatus {
    Ready = 1,
    Sitout = 2, // the user is currently sit out
    Disconnected = 3, // connection error by the server and may try to reconnect
    SitoutNextHand = 4, // user request to sit out of next hand but stay on the table
    LeftNextHand = 5, // user left the table while playing
    Cashier = 6, // user is out of money almost as sitout
    LeaveSeat = 7,  // user will leave it's seat (ring only)
    SitoutNextBB = 8, // player will leave the table next time he is the BB.
}